import { components } from "./components/index";
import { events } from "./events/index";


const DeclarationSection = {
  components,
  events
}

export { DeclarationSection };